import { EventEmitter, Output, ViewChild } from '@angular/core';
import { Component, OnInit, Inject, HostListener, NgZone, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, NgForm, FormControl } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { DeviceService } from 'src/app/services/data/device.service';
import { TrackerService } from 'src/app/services/data/tracker.service';
import { MapService } from 'src/app/services/map/map.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tracker-modal',
  templateUrl: './tracker-modal.component.html',
  styleUrls: ['./tracker-modal.component.scss']
})
export class trackerModalComponent implements OnInit, AfterViewInit {
  name;
  dataTracker = {
    latitude: "",
    longitude: "",
    altitude: "",
    batteryState: "",
    modelId: "",
    messengerId: "",
    messengerName: "",
    messageType: "",
    messageDetail: "",
    id: "",
    _id: "",
    dateTime: ""
  };
  panelOpenState = false;
  searchType;
  tipologia;
  azzeraRicercaVisible = false;
  dataSource;
  displayedColumns;
  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: '#393939',
      buttonColor: '#fff'
    },
    dial: {
      dialBackgroundColor: '#555',
    },
    clockFace: {
      clockFaceBackgroundColor: '#555',
      clockHandColor: '#a6161f',
      clockFaceTimeInactiveColor: '#fff'
    }
  };
  toppings: FormGroup;
  dataToVisualize;
  adesso;
  pickerDaData: Date;
  pickerAData: Date;
  pickerDaTime;
  pickerATime;
  constructor(
    private fb: FormBuilder,
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<trackerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngZone: NgZone,
    private trackerService: TrackerService,
    private mapService: MapService,
    private deviceService: DeviceService
  ) {
    this.name = this.data.name;
    this.trackerService.getMessageType(sessionStorage.getItem('region'));
    this.displayedColumns = ['position', 'Latitudine', 'Longitudine', 'Altitudine', 'Data'];
    this.dataSource = [];
    this.adesso = false;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  @ViewChild('btnRef') buttonRef: MatButton;


  ngOnInit(): void {
    this.trackerService.getLastPosition(this.name, sessionStorage.getItem("region"))
      .subscribe((res: any) => {
        this.dataTracker = res;
        this.dataToVisualize = new Date(res.dateTime).toLocaleString();
        this.mapService.drawSingleMarker(this.dataTracker);
        this.mapService.moveMap([res.latitude, res.longitude], 11, true);
      });
    this.trackerService.getMessageType(sessionStorage.getItem('region'))
      .subscribe((res: any) => {
        this.searchType = res;
      });
  }

  ngAfterViewInit() {
    this.buttonRef.focus();
  }

  async editName() {
    const { value: deviceName } = await Swal.fire({
      title: 'Cambio nome dispositivo',
      input: 'text',
      inputValue: this.name,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!'
        }
      }
    })

    if (deviceName && deviceName != this.name) {
      this.deviceService.changeDeviceAlias(this.dataTracker.messengerId, this.dataTracker.messengerName, deviceName)
        .subscribe((res: any) => {
          Swal.fire('Nome correttamente modificato');
          this.name = deviceName;
        }, (err: any) => {
          Swal.fire('Errore durante la modifica del nome');
        })
    }
  }

  onNoClick() {
    this.ngZone.run(() => {
      this.dialogRef.close();
      this.mapService.drawMarkers();
    });
  }

  ricerca(temporale) {
    this.dataSource = [];
    if (temporale) {
      let toReturn = false;
      if (this.pickerDaData == undefined || this.pickerDaTime == undefined) {
        toReturn = true;
      }
      if (this.pickerAData == undefined || this.pickerATime == undefined) {
        if (!this.adesso) toReturn = true;
      }
      if (toReturn) {
        this.printToast("Selezionare i campi richiesti");
        return;
      }
      this.pickerDaData.setHours(this.pickerDaTime.split(":")[0]);
      this.pickerDaData.setMinutes(this.pickerDaTime.split(":")[1]);
      if (this.adesso) {
        this.pickerAData = new Date();
      } else {
        this.pickerAData.setHours(this.pickerATime.split(":")[0]);
        this.pickerAData.setMinutes(this.pickerATime.split(":")[1]);
      }
      this.trackerService.getPositionByDate(this.pickerDaData.toISOString(), this.pickerAData.toISOString(), sessionStorage.getItem('region'))
        .subscribe((res: any) => {
          if (res.length == 0) {
            this.mapService.cleanLayers();
          } else {
            if (res.length == 1) {
              this.mapService.drawSingleMarker(res[0]);
            } else {
              for (let i = 0; i < res.length; i++) {
                this.dataSource.push({
                  position: i + 1,
                  latitudine: res[i].latitude,
                  longitudine: res[i].longitude,
                  altitudine: res[i].altitude,
                  data: new Date(res[i].dateTime).toLocaleString()
                });
                this.mapService.createMarker(res[i], i + 1);
              }
            }
          }
        });
      this.azzeraRicercaVisible = true;
    } else {
      if (this.tipologia) {
        this.trackerService.getPositionBySpotAndType(this.name, this.tipologia, sessionStorage.getItem('region'))
          .subscribe((res: any) => {
            if (res.length == 0) {
              this.mapService.cleanLayers();
            } else {
              if (res.length == 1) {
                this.mapService.drawSingleMarker(res[0]);
              } else {
                for (let i = 0; i < res.length; i++) {
                  this.dataSource.push({
                    position: i + 1,
                    latitudine: res[i].latitude,
                    longitudine: res[i].longitude,
                    altitudine: res[i].altitude,
                    data: new Date(res[i].dateTime).toLocaleString()
                  });
                  this.mapService.createMarker(res[i], i + 1);
                }
              }
            }
          });
        this.azzeraRicercaVisible = true;
      } else {
        this.printToast("Selezionare i campi richiesti");
      }
    }
  }

  printToast(messaggio) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });

    Toast.fire({
      icon: 'error',
      title: messaggio
    })
  }

  azzeraRicerca() {
    this.azzeraRicercaVisible = false;
    this.dataSource = [];
    this.tipologia = null;
    this.trackerService.getLastPosition(this.name, sessionStorage.getItem("region"))
      .subscribe((res: any) => {
        this.dataTracker = res;
        this.mapService.drawSingleMarker(this.dataTracker);
        this.mapService.moveMap([res.latitude, res.longitude], 11, true);
      });
  }

  switchExpansion() {
    this.azzeraRicerca();
  }

  updateDatePicker(event: MatDatepickerInputEvent<Date>, da) {
    if (da) {
      this.pickerDaData = new Date(event.value);
    } else {
      this.pickerAData = new Date(event.value);
    }
  }

  updateTimePicker(event, da) {
    if (da) {
      this.pickerDaTime = event;
    } else {
      this.pickerATime = event;
    }
  }

  @Output()
  change: EventEmitter<MatCheckboxChange>

  adessoClick(ob) {
    this.adesso = ob.checked;
  }
}
